import { render, staticRenderFns } from "./QuitCreateOfferDialog.vue?vue&type=template&id=5fa31a28&scoped=true&lang=pug&"
import script from "./QuitCreateOfferDialog.vue?vue&type=script&lang=js&"
export * from "./QuitCreateOfferDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuitCreateOfferDialog.vue?vue&type=style&index=0&id=5fa31a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa31a28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VDivider,VSpacer})
